<!--单位树组件-->
<template>
	<div class="readDeviceTreeBody hideBar" >
		<tree v-if="showTree" :imgMethod="imgMethod" :menuCheckedAble='true' :nowOpenFloorIds="nowOpenFloorIds" :dataList="dataList" :getIdMethod="getIdMethod" :nowCheckId="nowCheckId" @checkItem="checkItem"></tree>
	</div>
</template>

<script>
	import tree from './tree.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			tree
		},
		props: {
			fllowCache: {
				type: Boolean,
				default: () => {
					return false
				}
			},
		},
		data() {
			return {
				nowCheckId: '',
				nowCheckItem: {},
				nowOpenFloorIds: [],
				seconds: 60,
				timer: undefined,
				changeStatus:false,
				showTree: true
			}
		},
		created() {},
		mounted() {
			//加载以后默认选中第一个设备
			var interval = setInterval(() => {
				if(isempty(this.dataList)) {
					return
				}
				this.checkFirst(this.dataList)
				clearInterval(interval)
			}, 500)
		},
		destroyed() {},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			dataList() {
				var data = this.$store.unitStore.getters.getUnitTree
				return isempty(data) ? [] :[data]
			},
			freshImgUrl() {
				return this.$store.resourcesStore.getters.getResourcesByName('menu/menu.btn50.png')
			},
		},
		watch: {
			dataList(nv, ov) {
				if(isempty(ov)) {
					this.checkFirst(nv)
				}
			},
			nowUnit(nv,ov){
				if(this.fllowCache){
					this.nowCheckId = this.getIdMethod(this.nowUnit)
					this.nowCheckItem = this.nowUnit
				}
			},
			nowCheckItem(nv, ov) {
				this.$emit("checkItem", nv)
			}
		},
		methods: {
			changeShowType() {
				this.showTree = !this.showTree
			},
			checkFirst(dataList) {
				if(!isempty(this.nowUnit) && this.fllowCache){
					this.nowOpenFloorIds = this.getFistUnitAll(dataList)
					this.nowCheckId = this.getIdMethod(this.nowUnit)
					this.nowCheckItem = this.nowUnit
				}
				//选中最上级单位,展开第一层直到最底
				if(!isempty(dataList)) {
					this.nowOpenFloorIds = this.getFistUnitAll(dataList)
					this.nowCheckId = this.getIdMethod(dataList[0])
					this.nowCheckItem = dataList[0]
				}
			},
			getFistUnitAll(list) {
				var ol = []
				if(list[0] != undefined) {
					ol.push(this.getIdMethod(list[0]))
					if(!isempty(list[0].next)) {
						ol = ol.concat(this.getFistUnitAll(list[0].next))
					}
				}
				return ol
			},
			imgMethod(item) {
				if(isempty(this.nowCheckItem)|| (item.id!=this.nowCheckItem.id)){
					return resourcesStore.getters.getResourcesByName("tree/manage_user_unit.png")
				}else{
					return resourcesStore.getters.getResourcesByName("tree/manage_user_unit_select.png")
				}
			},
			getIdMethod(item) {
				return item.id
			},
			checkItem(item) {
				this.nowCheckId = this.getIdMethod(item)
				this.nowCheckItem = item
			},
			// 开始自动切换
			startAutoChange() {
				if(this.seconds == undefined || this.seconds < 0){
					return
				}
				this.changeStatus = true
				addNewTask('autoChangeTimer', 0, this.seconds * 1000, -1, () => {
					removeTask('carouselTimer')
					this.searchNext(this.dataList, this.nowCheckId)
				})
				setTimeout(()=>{
					this.checkFirst(this.dataList)
				},10)
			},
			// 停止自动切换
			stopAutoChange() {
				this.changeStatus = false
				removeTask('autoChangeTimer')
			},
			searchNext(list, id) {
				for(let i = 0;i < list.length;i++){
					if(list[i].id == id){
						if(!!list[i].next && list[i].next.length > 0){
							this.checkItem(list[i].next[0])
						}else if(!!list[i+1]){
							this.checkItem(list[i+1])
						}else{
							this.checkFirst(this.dataList)
						}
					}else if(!isempty([i].next)){
						this.searchNext(list[i].next, id)
					}
				}
			},
			listenKeydown(ev) {
				if(ev.keyCode == 109 || ev.keyCode == 110 || ev.keyCode == 190 || ev.keyCode == 229){
					ev.preventDefault()
				}
			}
		}
	}
</script>

<style scoped>
	.readDeviceTreeBody {
		height: 100%;
		overflow: auto;
		background: #E3E9EE;
	}
</style>